var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"/images/notifications/team-alignment.svg","alt":"","aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }